var targetNode = document.getElementById('te-modal-content');

var config = { childList: true, subtree: true };

var callback = function(mutationsList, observer) {
    for (var mutation of mutationsList) {
        if (mutation.type === 'childList') {
            var variantRecharge = document.querySelectorAll('#te-modal-content .rc_purchase_type');
            console.log(variantRecharge)
            variantRecharge.forEach(variant => {
                var label = variant.querySelector('label');
                if (label && label.textContent.includes('Taille')) {
                    variant.style.display = 'none';
                }
            });
        }
    }
};

var observer = new MutationObserver(callback);
if (targetNode) {
    observer.observe(targetNode, config);
}
